// extracted by mini-css-extract-plugin
export default {"modal":"Statistic_modal__LASP2","close_button":"Statistic_close_button__cZFDo"};